const t = {
  name: "Cash",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 8C9.78771 8 8 9.78771 8 12C8 14.2123 9.78771 16 12 16C14.2123 16 16 14.2123 16 12C16 9.78771 14.2123 8 12 8ZM10 12C10 10.8923 10.8923 10 12 10C13.1077 10 14 10.8923 14 12C14 13.1077 13.1077 14 12 14C10.8923 14 10 13.1077 10 12Z" fill="currentColor"/>
<path d="M20 11H17V13H20V11Z" fill="currentColor"/>
<path d="M4 11H7V13H4V11Z" fill="currentColor"/>
<path d="M24 4H0V20H24V4ZM2 18V6H22V18H2Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Cash
};
